import React, { Component } from 'react';
import { connect } from 'react-redux';
import Btn from '../global/button';
import TranslatedCopy from '../../intl/translated-copy';

import { HomeE4 } from '../../../routing/urls';

import { sendAnalytics } from '../../../scripts/analytics/tracker';
import manageTracking from '../../../scripts/analytics/creators/manage';

const mapStateToProps = state => ({
  isActiveFlowCorporate: state.Corporate.isActiveFlowCorporate,
});
class ErrorModal extends Component {
  constructor(props) {
    super(props);

    const {
      apiError,
    } = props;

    this.state = {
      apiErrorCode: apiError?.errorData?.code,
    };

    this.handleBtnReloadClick = this.handleBtnReloadClick.bind(this);
  }

  componentWillMount() {
    const {
      apiError,
      dispatch,
    } = this.props;
    const {
      apiErrorCode,
    } = this.state;

    const excludedCodes = ['13330701', '13330301', '13330302', '204128'];
    const isUpgradeVoucherRedeemedError = ['SET_UPGRADE_VOUCHER_FAIL', 'RETRIEVE_UPGRADE_VOUCHER_FAIL'].includes(apiError?.actionType) && apiError?.errorData?.statusCode === 200;
    // Validacion para errores de token y desconexion sabre en pagos
    if (apiErrorCode && apiErrorCode !== '13110305' && apiErrorCode !== '13110304' && apiErrorCode !== '13110306' && apiErrorCode !== '13110307' && apiErrorCode !== '13110308' && !isUpgradeVoucherRedeemedError) {
      if (apiErrorCode !== undefined && !excludedCodes.includes(apiErrorCode)) {
        dispatch(sendAnalytics({
          eventCreator: manageTracking.errorTracking(apiError),
        }));
      }
    }
  }

  render() {
    return (
      <div className='ErrorModal'>
        <div className='Modal-Baggage'>
          <div className='Modal-Baggage__container'>
            <section className='AncillaryModalBaggage'>
              <section className='AncillaryModalBaggage-content'>
                { this.renderError() }
              </section>
            </section>
          </div>
        </div>
      </div>
    );
  }

  renderError() {
    return (
      <div className='ErrorModal-content'>
        { this.renderModalHeader() }
        { this.renderModalBody() }
      </div>
    );
  }

  renderModalHeader() {
    const {
      apiErrorCode,
    } = this.state;

    return (
      <header className='ErrorModal-header'>
        <TranslatedCopy
          className='ErrorModal-title'
          copyID='WERE_SORRY'
          tagName='h2' />
        {
          apiErrorCode &&
          <div className='ErrorModal-errorNum'>
            <TranslatedCopy
              code={ apiErrorCode }
              copyID='ERROR_CODE' />
          </div>
        }
      </header>
    );
  }

  renderModalBody() {
    return (
      <div className='ErrorModal-body'>
        { this.renderErrorMessage() }
        <Btn
          className='Icon Icon--reload ErrorModal-btn'
          onBtnClick={ this.handleBtnReloadClick }
          filled={ true }
          copyID='RETRY_CTA' />
      </div>
    );
  }

  renderErrorMessage() {
    const {
      errorMessage,
      isActiveFlowCorporate,
    } = this.props;

    const message = errorMessage ?
      <div className='error-Message-custom'>
        <p className='u-textLarge'>{ errorMessage }</p>
      </div> :
      <div className='error-Message-default'>
        <TranslatedCopy
          className='u-textLarge'
          copyID={ isActiveFlowCorporate ? 'MYB_CORP_ERROR' : 'APP_DEFAULT_ERROR'} 
          tagName='p' />
      </div>;
    return (
      <div className='ErrorModal-description'>
        { message }
      </div>
    );
  }

  handleBtnReloadClick() {
    const {
      country,
      language,
    } = this.props;

    window.location.href = HomeE4(language, country);
  }
}

ErrorModal = connect(mapStateToProps)(ErrorModal);

export default ErrorModal;
